define([
    'underscore',
    'edge/quoteandbind/common/models/Person',
    'integration/quoteandbind/PolicyLineExtensionConfiguration'
], (_, Person, PolicyLineExtensionConfiguration)=> {
    let _nextId = 1;

    function Submission(data) {
        // PROCESS
        if (data) {
            data.persons = [];

            data.draftData.accountHolder = this._forcePerson(data, data.draftData.accountHolder);
            if (data.draftData.accountHolder) {
                if (!data.draftData.accountHolder.subtype) {
                   data.draftData.accountHolder.subtype = 'Person';
                }
                data.draftData.accountHolder.accountHolder = true;

                //Sanitisation for data coming from core products. This can cause problems returning to backend
                _.map(['prefix', 'suffix'], (key) => {
                    data.draftData.accountHolder[key] = undefined;
                });
            }

            _.extend(this, data);
            _.map(this.persons, (p) => {
                _.map(['prefix', 'suffix'], (key) => {
                    p[key] = undefined;
                });
            });

        } else {
            this.persons = [];

            this.draftData = {
                accountHolder: {
                    subtype: 'Person',
                    accountHolder: true
                },
                // commented out to test default eff dt --Arpita Sengupta
                // periodStartDate: new Date(),
                // ended
                lobs: {}
            };
        }
        this.draftData.questionSetNames = [];

        PolicyLineExtensionConfiguration.mixinLobDraftDataExtensions(this);
    }

    Submission.prototype.createId = function () {
        return _nextId++;
    };

    Submission.prototype.nextId = function () {
        return _nextId++;
    };

    // PERSON
    Submission.prototype.createPerson = function (/*options*/) {
        const person = new Person({
            tempId: _nextId++
        });
        this.persons.push(person);
        return person;
    };

    // UTILS
    Submission.prototype.getAccountHolderPerson = function () {
        return this.draftData.accountHolder;
    };

    Submission.prototype.submissionExists = function () {
        return !!this.quoteID;
    };

    Submission.prototype.findPerson = function (submission, person) {
        if (_.isEmpty(person)) {
            return null;
        }

        return this._forcePerson(submission, person);
    };

    Submission.prototype._forcePerson = function (submission, person) {
        let p = person.publicID ? _.findWhere(submission.persons, {publicID: person.publicID}) : null;
        if (!p) {
            p = new Person(person);
            p.tempId = _nextId++;
            submission.persons.push(p);
        }
        return p;
    };

    return Submission;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/models/Submission.js
 **/